import React from 'react'
import { useTheme } from '../contexts/ThemeContext'
import { MoonIcon, SunIcon } from '@heroicons/react/24/outline'

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme()

  return (
    <button
      onClick={toggleTheme}
      className="p-2 rounded-lg bg-[#ffa724] text-black hover:bg-[#ff9710] transition-colors duration-200"
      aria-label="Toggle theme"
      title={theme === 'light' ? 'Switch to dark mode' : 'Switch to light mode'}
    >
      {theme === 'light' ? (
        <MoonIcon className="w-5 h-5" />
      ) : (
        <SunIcon className="w-5 h-5" />
      )}
    </button>
  )
}

export default ThemeToggle
